export default {"src":"/_next/static/media/lightning protection logo.3de6077c.svg","height":61,"width":163,"blurWidth":0,"blurHeight":0};